import { Component } from '@angular/core';
import { MAPSUploadedDocumentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Uploaded Documents') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapsuploadeddocument-form',
    templateUrl: './mapsuploadeddocument.form.component.html'
})
export class MAPSUploadedDocumentFormComponent extends BaseFormComponent {
    public record!: MAPSUploadedDocumentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

